import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
	{
		name: 'Inventory Count',
		url: '/products/inventories',
		icon: 'list-ul',
	},
];

export default class Inventories extends Framework.Components.View {
	render() {
		return (


			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.toggle('modalInventory')} size="sm" color="primary">
						<i className="fa fa-list-ul"/>&nbsp;&nbsp;Start Inventory Count
					</Button>
				</Framework.Components.PageBar>

				<Collections.Inventories
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<UniversalModalOverride
					title="Start Inventory Count"
					submitLabel="Start Inventory"
					locations={this.props.locations}
					states={this.props.states}
					name="Inventory"
					object={Objects.Inventory}
					history={this.props.history}
					toggle={this.state['modalInventory']}
					reportClose={this.reportClose('modalInventory')}
					afterSave={this.handleAfterSave}
				/>

			</div>
		);
	}
}

